import { useEffect } from "react";

/** File inputs call scrollIntoView and can shift AdminLayout's overflow shell. */
export function pinAdminShellScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const shell = document.querySelector("#root > div");
  if (shell && shell.scrollTop !== 0) shell.scrollTop = 0;
}

/**
 * While this form is mounted, keep the admin shell pinned so file-picker
 * focus/scrollIntoView cannot leave a white gap under the page.
 * Does not modify AdminLayout — only resets scroll when it drifts.
 */
export function usePinAdminShellScroll() {
  useEffect(() => {
    const shell = document.querySelector("#root > div");
    if (!shell) return undefined;

    const pin = () => pinAdminShellScroll();
    pin();
    shell.addEventListener("scroll", pin, { passive: true });
    window.addEventListener("scroll", pin, { passive: true });
    return () => {
      shell.removeEventListener("scroll", pin);
      window.removeEventListener("scroll", pin);
    };
  }, []);
}

/** Open a hidden file input without letting the shell scroll away. */
export function openFileInputSafely(input) {
  if (!input) return;
  const main = document.querySelector("main");
  const mainScroll = main?.scrollTop ?? 0;
  const restore = () => {
    pinAdminShellScroll();
    if (main) main.scrollTop = mainScroll;
  };
  restore();
  input.click();
  requestAnimationFrame(restore);
  setTimeout(restore, 0);
  setTimeout(restore, 50);
  setTimeout(restore, 200);
  setTimeout(restore, 400);
}
